module.exports = __webpack_public_path__ + "static/media/preview.b5543629.jpg";